import "./slotStyles.css";
import { useState, useEffect } from "react";

const pathString = "./stageAssets/stage0/slot-machine-icons/";

const reelItems = [
  { name: "Unknown", src: "slotX.jpg" },
  { name: "Plant", src: "slot3.jpg" },
  { name: "Animal", src: "slot2.jpg" },
  { name: "Human", src: "slot1.jpg" },
  { name: "Animal", src: "slot4.jpg" },
  { name: "Plant", src: "slot5.jpg" },
  { name: "Animal", src: "slot6.jpg" },
  { name: "Animal", src: "slot7.jpg" },
  { name: "Plant", src: "slot8.jpg" },
  { name: "Plant", src: "slot9.jpg" },
  { name: "Plant", src: "slot10.jpg" },
  { name: "Animal", src: "slot11.jpg" },
];

export default function SlotMachine({ onComplete, playerMode = "human" }) {
  const HUMAN_FORM_INDEX = 3; // slot1.jpg
  const PLANT_FORM_INDEX = 10; // slot10.jpg

  const HUMAN_CHROMOSOME_PAIRS = 23;
  const PLANT_CHROMOSOME_PAIRS = 41;

  const randomTwoDigit = () => Math.floor(Math.random() * 90) + 10;

  const [spinning, setSpinning] = useState(false);
  const [finalOutcomes, setFinalOutcomes] = useState([]);
  const [showResultModal, setShowResultModal] = useState(false);

  const [currentReels, setCurrentReels] = useState([
    reelItems[0],
    reelItems[0],
    reelItems[0],
  ]);

  const [chromosomePairCount, setChromosomePairCount] = useState(1);

  // decide final outcome based on playerMode
  const isPlant = playerMode === "plant";

  const targetFormIndex = isPlant ? PLANT_FORM_INDEX : HUMAN_FORM_INDEX;
  const targetChromosomePairs = isPlant
    ? PLANT_CHROMOSOME_PAIRS
    : HUMAN_CHROMOSOME_PAIRS;

  const targetLabel = isPlant ? "PLANTA" : "HUMANO";
  const introText = isPlant
    ? "Contra todas as chances…"
    : "Contra chances quase impossíveis…";

  useEffect(() => {
    handleSpin();
  }, []);

  const handleSpin = () => {
    setSpinning(true);
    setFinalOutcomes([]);
    setShowResultModal(false);

    setChromosomePairCount(randomTwoDigit());

    // all 3 reels land on the target form
    const results = [targetFormIndex, targetFormIndex, targetFormIndex];

    let spinCount = 0;

    const interval = setInterval(() => {
      setCurrentReels([
        reelItems[Math.floor(Math.random() * reelItems.length)],
        reelItems[Math.floor(Math.random() * reelItems.length)],
        reelItems[Math.floor(Math.random() * reelItems.length)],
      ]);

      spinCount++;
      setChromosomePairCount(randomTwoDigit());

      if (spinCount >= 30) {
        clearInterval(interval);

        setCurrentReels([
          reelItems[results[0]],
          reelItems[results[1]],
          reelItems[results[2]],
        ]);

        setFinalOutcomes(results.map((index) => reelItems[index]));
        setSpinning(false);
        setChromosomePairCount(targetChromosomePairs);

        setTimeout(() => setShowResultModal(true), 900);
      }
    }, 100);
  };

  const handleOk = () => {
    setShowResultModal(false);
    onComplete?.();
  };

  const handleTerminate = () => {
    setShowResultModal(false);
    window.location.reload();
  };

  return (
    <div className="slot-machine-container">
      <h1 className="dna-line">
        Seu Vaso é formado por {" "}
        <span className="chromosome-number">{chromosomePairCount}</span>{" "}
        pares de cromossomos.
      </h1>

      <div className="reels">
        {currentReels.map((item, index) => (
          <div className="reel" key={index}>
            <img src={`${pathString}${item.src}`} alt={item.name} />
          </div>
        ))}
      </div>

      <div className="results" />

      {showResultModal && (
        <div className="slot-modal-overlay">
          <div className="slot-modal">
            <p>{introText}</p>
            <h2>Você assumirá a forma de:</h2>
            <h1 className="slot-result-label">{targetLabel}</h1>
            <button onClick={handleTerminate}>Encerrar Jornada</button>
            <button onClick={handleOk}>Continuar Jornada</button>
          </div>
        </div>
      )}
    </div>
  );
}